module.exports = __webpack_public_path__ + "img/blog-2-post-cover.d2e68f5c.webp";